import clsx from 'clsx';

import { DataType } from '@atom/types/dataType';
import {
  getDisplayDateTime,
  setDisplayDate,
} from '@atom/utilities/timeUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { MappedField } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  field: MappedField;
  isTitleField?: boolean;
}

const getTitle = (field: MappedField, isTitleField: boolean) => {
  const requiredTitle = field?.required ? `*${field?.title}` : field?.title;
  const showEndAdornment = isTitleField ? !isNilOrEmpty(field.value) : true;

  return (
    <span>
      <span>{requiredTitle}</span>
      {!isNilOrEmpty(field?.units) && (
        <span className={classes.unit}>{` (${field?.units})`}</span>
      )}
      {showEndAdornment && <span>{`: `}</span>}
    </span>
  );
};

const getValueDisplay = (field: MappedField) => {
  if (isNilOrEmpty(field?.value)) {
    return <span className={classes.emptyValue}>space for values</span>;
  }

  if (field?.dataType === DataType.SUMMARY) {
    return <span className={classes.summaryValue}>{field?.value}</span>;
  }

  if (field?.dataType === DataType.DATE) {
    return <span>{setDisplayDate(field?.value)}</span>;
  }

  if (field?.dataType === DataType.DATE_TIME) {
    return <span>{getDisplayDateTime(field?.value)}</span>;
  }

  if (field?.dataType === DataType.ENUM_MULTIPLE) {
    return <span>{field?.value.join(', ')}</span>;
  }

  if (field?.dataType === DataType.HYPERLINK) {
    return (
      <span className={classes.linkValue}>
        <a href={field?.hyperlink} target="_blank">
          {field?.value}
        </a>
      </span>
    );
  }

  return <span>{field?.value}</span>;
};

const CustomFieldCell = ({ field, isTitleField }: Props) => {
  const title = getTitle(field, isTitleField);
  const value = getValueDisplay(field);
  const style = clsx(classes.customFieldTile, isTitleField && classes.title);

  return (
    <div className={style}>
      <div>
        {title}
        {value}
      </div>
    </div>
  );
};

export default CustomFieldCell;
